// Data untuk Program Bimbel - Optimized for SEO
export const programs = [
  {
    id: 1,
    title: "Bimbel TKA",
    subtitle: "SD, SMP & SMA",
    description:
      "Les privat dan bimbel persiapan TKA untuk SD, SMP, dan SMA di seluruh Indonesia. Materi terstruktur, latihan rutin, dan pendampingan intensif dari tutor berpengalaman.",
    image: "tka.webp",
  },
  {
    id: 2,
    title: "Bimbel",
    subtitle: "SNBT & UM PTN",
    description:
      "Program bimbingan belajar persiapan masuk PTN favorit melalui jalur SNBT dan Ujian Mandiri. Strategi pengerjaan soal, tryout rutin, dan pembahasan mendalam bersama mentor alumni PTN.",
    image: "snbt.webp",
  },
  {
    id: 3,
    title: "Bimbel",
    subtitle: "CPNS & CPPPK",
    description:
      "Kursus persiapan tes CPNS dan CPPPK terlengkap di seluruh Indonesia. Materi TWK, TIU, TKP dengan simulasi CAT terbaru dan pembahasan soal sesuai standar BKN.",
    image: "cpns.webp",
  },
  {
    id: 4,
    title: "Bimbel",
    subtitle: "Polri & TNI",
    description:
      "Program bimbel khusus persiapan seleksi Polri dan TNI. Meliputi tes akademik, psikotes, dan pembinaan mental. Tersedia offline di seluruh Indonesia dan online.",
    image: "polisi_tni.webp",
  },
  {
    id: 5,
    title: "Bimbel Kedinasan",
    subtitle: "STAN, STIS, IPDN",
    description:
      "Les intensif persiapan tes sekolah kedinasan seperti STAN, STIS, IPDN, dan lainnya. Materi terarah, latihan soal berkala, dan strategi lolos seleksi tahap demi tahap.",
    image: "kedinasan.webp",
  },
  {
    id: 6,
    title: "Bimbel Rekrutmen",
    subtitle: "BUMN & BUMS",
    description:
      "Persiapan tes rekrutmen BUMN dan perusahaan swasta. Fokus pada kemampuan dasar, psikotes, dan simulasi soal sesuai kebutuhan dunia kerja profesional.",
    image: "bumn.webp",
  },
];


// Data untuk Testimonials
export const testimonials = [
  {
    id: 1,
    name: "Chandra Rafiyanto",
    university: "Lulus CPT Kemenkumham",
    image: "/photo/testimonial/Chandra.webp",
    quote:
      "Brilliant Indonesia bener-bener game changer 🔥 Awalnya saya cuma coba-coba ikut bimbel, tapi ternyata materinya relevan banget sama soal tes CPT. Pembahasannya ngena, cara ngajarnya santai tapi daging, jadi gak ngebosenin sama sekali. Dari yang awalnya bingung sama materi, sekarang jadi paham dan lebih pede buat berkembang. Highly recommended buat kamu yang mau level up!",
  },
  {
    id: 2,
    name: "Rendra Ardiansyah",
    university: "Lulus CPNS Tenaga Kesehatan",
    image: "/photo/testimonial/Rendra.webp",
    quote:
      "Mentor-mentornya sangat berpengalaman dan super sabar banget ngajarin sampai paham. Materi yang diberikan lengkap mulai dari TWK, TIU, sampai TKP, semuanya up-to-date sesuai kurikulum terbaru CPNS. Tryout-nya juga rutin, jadi makin terlatih ngerjain soal dengan cepat dan tepat. Alhamdulillah bisa lolos jadi PNS!",
  },
  {
    id: 3,
    name: "Kenzie Muhammad Rizieq",
    university: "Lulus SNBT 2024 UGM",
    image: "/photo/testimonial/Kenzie.webp",
    quote:
      "Saya mengikuti program PTN dari kelas 11 SMA dengan persiapan yang cukup untuk menembus UGM (universitas impian saya), namun saya gagal pada saat tes UTBK, mungkin karena kuota yang terbatas dan persaingan yang sangat ketat, akan tetapi Brilliant tidak menyerah kepada saya, Brilliant merekomendasikan saya untuk mengambil tes UM UGM. Dengan Brilliant, saya kembali belajar soal-soal UM dan Alhamdulillah lulus di Proteksi Tanaman UGM. Terimakasih banyak Brilliant karena tidak hanya mengajari saya, namun juga memberikan opsi terbaik untuk saya.",
  },
  {
    id: 4,
    name: "Muhammad Hafidz",
    university: "Lulus CPNS Dosen",
    image: "/photo/testimonial/Hafizh.webp",
    quote:
      "Bimbel terbaik yang pernah saya ikuti! Sistem belajarnya super fleksibel, bisa online atau offline sesuai kebutuhan kita. Materi khusus untuk seleksi dosen sangat membantu, terutama di bagian tes substansi dan wawasan kebangsaan. Mentor-mentornya juga responsif kalau ada yang mau ditanyain. Pokoknya recommended banget buat yang mau jadi dosen!",
  },
  {
    id: 5,
    name: "Zaki",
    university: "Lulus STIP 2022",
    image: "/photo/expandTestimonial/Zaki_STIP.jpg",
    quote:
      "Awalnya saya masuk Brilliant karena minat saya untuk masuk kedinasan dan PTN, lalu diajak oleh sahabat saya juga, setelah mengikuti pembelajaran di Brilliant, materi yang disampaikan sangat mudah dipahami dan metode yang diajarkan sangat membantu saya dalam menjawab soal-soal pada try out. Alhamdulillah saat mengikuti tes, saya mendapatkan nilai yang sangat memuaskan, soal-soal yang diajarkan sebelumnya sangat membantu saya. Terimakasih Brilliant, sudah membantu saya untuk lulus di STIP dan Teknik Sipil Unsri.",
  },
  {
    id: 6,
    name: "Gifari Rasyid",
    university: "Lulus TNI AD",
    image: "/photo/testimonial/Gifari.webp",
    quote:
      "Dari awal tidak percaya diri dan merasa kemampuan akademik saya kurang, tapi Brilliant ngasih motivasi dan bimbingan yang tepat. Latihan soal tes akademik dan psikotesnya mirip banget sama yang keluar pas seleksi TNI AD. Sekarang impian saya jadi kenyataan, sudah diterima di TNI AD. Terima kasih banyak Brilliant Indonesia!",
  },
];

// Data untuk Expandable Testimonials Grid
export const expandableTestimonials = [
  {
    id: 1,
    name: "Azkya Mursalim",
    acceptance: "Lulus CPNS Kejaksaan",
    image: "/photo/expandTestimonial/AzkyaMursalim_CPNSJaksa.jpg",
    quote:
      "Materi SKD & SKB-nya daging semua! Mentornya paham betul pola soal CPNS Kejaksaan tahun ini. Alhamdulillah strategi 'tembak jitu' yang diajarin bikin saya lolos perankingan di formasi Jaksa.",
  },
  {
    id: 2,
    name: "Geri",
    acceptance: "Lulus Bintara Polri",
    image: "/photo/expandTestimonial/Geri_Polisi.jpg",
    quote:
      "Persiapan tes akademik dan psikotes di sini bener-bener terarah. Latihan soalnya akurat banget sama tes aslinya, jadi pas hari H udah nggak kaget lagi. Bangga bisa pakai seragam ini!",
  },
  {
    id: 3,
    name: "Raju & Yusran",
    acceptance: "Lulus Bintara Polri",
    image: "/photo/expandTestimonial/Raju&Yusran_Polisi.jpg",
    quote:
      "Belajar bareng di Brilliant bikin kita berdua makin semangat. Tips trik ngerjain soal matematikanya cepet banget, ngebantu banget pas tes akademik Polri kemarin. Sukses bareng itu nyata!",
  },
  {
    id: 4,
    name: "Yuriga",
    acceptance: "Lulus CPNS Kemenkumham SKD tertinggi se-provinsi 478",
    image: "/photo/expandTestimonial/Yuriga _CPNSKemenkumham.webp",
    quote:
      "Awalnya ragu bisa tembus Kemenkumham karena saingannya ribuan. Tapi berkat bimbingan intensif dan tryout rutin di sini, skor SKD saya melonjak drastis dan aman sampai tahap akhir.",
  },
  {
    id: 5,
    name: "Nata Akbari Syaifullah",
    acceptance: "Lulus CPNS Kemenkumham",
    image: "/photo/testimonial/Nata.webp",
    quote:
      "Masuk sekolah kedinasan impian kayak STIP rasanya mustahil kalau belajar sendiri. Brilliant ngebantu banget bedah soal TPA dan TBI-nya sampai ke akar-akarnya. Recommended buat pejuang kedinasan!",
  },
];
